// extracted by mini-css-extract-plugin
module.exports = {"inactiveDot":"StatusDot_inactiveDot__3jKfD","dot":"StatusDot_dot__2_4Vn"};